// extracted by mini-css-extract-plugin
export default {"title-node-container":"TitleNode_title-node-container__eqEJA","label":"TitleNode_label__OtZRS"};